import { useState, Suspense } from "react";
import "./App.css";
import { useEagerConnect, useInactiveListener } from "./hooks/useEagerConnect";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  Home,
  CreatePassword,
  SecretRecoveryPhase,
  EnterRecoveryPhase,
  Dashboard,
  Congrats,
} from "./screens";
import { ScrollToTop } from "./components";

function App() {
  const [errorMessage, setErrorMessage] = useState();

  useEagerConnect(setErrorMessage);
  useInactiveListener();
  // const checkwalletExist = async () => {
  //   let walletExist = await calls.wallet_exixt();
  //   console.log(walletExist);
  // };
  // useEffect(() => {
  //   checkwalletExist();
  // }, []);

  return (
    <div className="App">
      {errorMessage ? <div style={{ color: "red" }}>{errorMessage}</div> : null}
      <BrowserRouter>
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create-password" element={<CreatePassword />} />
          <Route
            path="/secrete-recovery-phase"
            element={<SecretRecoveryPhase />}
          />
          <Route
            path={"/enter-recovery-phase"}
            element={<EnterRecoveryPhase />}
          />
          <Route path={"/congrats"} element={<Congrats />} />
          <Route path={"/dashboard"} element={<Dashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
// export default App;
export default function WrappedApp() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
  );
}
